import React, {useEffect, useRef, useState} from "react";
import './search-format-input.scss';
import FormatSlider from '../../../../molecules/seach-bar-components/formats/format-slider/format-slider';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../../../store/configureStore';
import {clubFinderSearchBarSliceActions} from '../../../../../store/slices/clubFinderSearchBarSlice';
import {Config} from "../../../../../constants/Config";

const baseClass = 'clubFinder-searchFormatInputBox';
const MobileViewWidth = Config.breakpoints.large.width;

interface PropTypes {
  inputBoxIcon?: string;
  label: string;
  placeholder?: string
  formatDetailsObject?: any
}

const SearchFormatInput = (props: PropTypes): JSX.Element => {
  const dispatch = useDispatch();
  const ref = useRef<HTMLInputElement>(null);
  const activeSearchFilter: any = useSelector((state: RootState) => state.clubFinderSearchBarStore.activeSearchFilterMobile)
  const [isInputFocused, setInputFocus] = useState(false);
  const [selectedFormatObject, setSelectedFormatObject] = useState([]);
  const [selectedFormatTitles, setSelectedFormatTitles] = useState([]);
  const [isEditable, setEditable] = useState(false);
  const [isFormatSliderHidden, setFormatSliderHidden] = useState(false);
  const [isMouseOverResults, setIsMouseOverResults] = useState(false);
  const savedFormatFilter: any = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedFormat);
  const savedFormatFilterName: any = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedFormatFilterName);
  const widgetWidth: any = useSelector((state: RootState) => state.widgetConfigurationSettings.widgetParentWidth);

  useEffect(() => {
    if (savedFormatFilter && savedFormatFilter?.length > 0) {
      setEditable(true);
      setSelectedFormatObject(savedFormatFilter);
      setSelectedFormatTitles(savedFormatFilterName);
    } else {
      setEditable(false);
    }
    if (widgetWidth < Config.breakpoints.large.width) {
      setFormatSliderHidden(activeSearchFilter.formatFilter);
    }
  }, [savedFormatFilter, activeSearchFilter, savedFormatFilterName, widgetWidth])

  const handleFormatSelectAction = () => {
    setFormatSliderHidden(true);
    setInputFocus(true);
    dispatch(clubFinderSearchBarSliceActions.activeSearchFilterMobile({location: false, format: true, gender: false}))
  }

  const setSelectedFormat = (selectedFormat: any, formatTitle: any) => {
    const tempFormatObject = [...selectedFormatObject];
    const selectedFormatTitlesObject = [...selectedFormatTitles];
    // @ts-ignore
    tempFormatObject.push(...selectedFormat)
    setSelectedFormatObject([...tempFormatObject])
    // @ts-ignore
    selectedFormatTitlesObject.push(formatTitle)
    setSelectedFormatTitles([...selectedFormatTitlesObject]);
    if (ref && ref.current) {
      // @ts-ignore
      ref?.current?.focus()
    }
  }

  const removeSelectedFormat = (removedPlayhqFormat: any, removedFormatTitle: any) => {
    const arrayForSort = [...selectedFormatObject]
    for (let i = 0; i < arrayForSort.length; i++) {
      for (let j = 0; j < removedPlayhqFormat.length; j++) {
        if (removedPlayhqFormat[j] === arrayForSort[i]) {
          arrayForSort.splice(i, 1);
        }
      }
    }
    setSelectedFormatObject(arrayForSort);
    const formatTitlesObject = [...selectedFormatTitles]
    for (let k = 0; k < formatTitlesObject.length; k++) {
      if (formatTitlesObject[k] === removedFormatTitle) {
        formatTitlesObject.splice(k, 1);
      }
    }
    setSelectedFormatTitles(formatTitlesObject);
    if (ref && ref.current) {
      ref.current.focus()
    }
  }

  const handleNextButton = () => {
    setFormatSliderHidden(false);
    setInputFocus(false);
    dispatch(clubFinderSearchBarSliceActions.setSavedFormatFilter({selectedFormatObject, selectedFormatTitles}))
    if (widgetWidth < Config.breakpoints.large.width) {
      dispatch(clubFinderSearchBarSliceActions.activeSearchFilterMobile({location: false, format: false, gender: true}))
    }
  }

  const onBlurHandler = () => {
    if (!isMouseOverResults) {
      setInputFocus(false);
      dispatch(clubFinderSearchBarSliceActions.setSavedFormatFilter({selectedFormatObject, selectedFormatTitles}))
    }
  }

  const onMouseOverHandler = (event: React.MouseEvent<HTMLDivElement>): void => {
    setIsMouseOverResults(true);
  }
  const onMouseOutHandler = (event: React.MouseEvent<HTMLDivElement>): void => {
    setIsMouseOverResults(false);
  }

  let selectedFormatText = null;
  if (selectedFormatTitles && selectedFormatTitles.length > 1) {
    selectedFormatText = `${selectedFormatTitles[0]} + ${selectedFormatTitles.length - 1}`;
  } else {
    selectedFormatText = selectedFormatTitles[0];
  }

  let formatSliderContent;
  if (widgetWidth < Config.breakpoints.large.width) {
    formatSliderContent = isFormatSliderHidden
  } else {
    formatSliderContent = isInputFocused
  }

  const inputContainerClickedHandler  = () => {
    if (widgetWidth > MobileViewWidth) {
      setInputFocus(true);
      if (ref && ref.current) {
        ref.current.focus();
      }
    }
  }

  return (
    <div
      onClick={inputContainerClickedHandler}
      className={`${baseClass} ${isInputFocused ? 'is-focused' : 'not-focused'}`}>
      <div className={`${baseClass}--header-button-wrapper ${isInputFocused ? 'is-focused' : 'not-focused'}`}>
        <div className={`${baseClass}--input-container`}>
          <div className={`${baseClass}--input-container-label`}>{props.label}</div>
          {isFormatSliderHidden && (
            <div className={`${baseClass}--sub-heading`}>How do you want to play?</div>
          )}
          {!isFormatSliderHidden && (isEditable) && !isInputFocused && (
            <div className={`${baseClass}--selected-text`}>Selected format
              ({selectedFormatText})</div>
          )}
          <input
            type='text'
            placeholder={props.placeholder}
            onBlur={() => onBlurHandler()}
            onClick={() => setInputFocus(!isInputFocused)}
            value={selectedFormatText ? selectedFormatText : ''}
            ref={ref}
            readOnly={true}
          />
        </div>
        {!isFormatSliderHidden && (
          <div className={`${baseClass}--right-input-action`} onClick={handleFormatSelectAction}>
            {isEditable ? 'Edit' : 'Add'}
          </div>
        )}
      </div>
      {formatSliderContent && (
        <div className={`${baseClass}--formats-slider-container`} onMouseOver={onMouseOverHandler}
             onMouseOut={onMouseOutHandler}>
          {props.formatDetailsObject && (
            <FormatSlider formatDetailsObject={props.formatDetailsObject} handleNextButton={handleNextButton}
                          setSelectedFormat={(selectedFormats: any, formatTitle: any) => setSelectedFormat(selectedFormats, formatTitle)}
                          removeSelectedFormat={(removedPlayhqFormat: string, removedFormatTitle: any) => removeSelectedFormat(removedPlayhqFormat, removedFormatTitle)}/>
          )}
        </div>
      )}
    </div>
  )
}

export default SearchFormatInput;
